import React from "react";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import axios from "axios";
import { Login_Page } from "../../Configuration/API_URL";
import { Link } from "react-router-dom";
import Formnav from "./FormNav";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Constants } from "../../CommonMethhods/Constants";

function ForgetPasswordForm() {
  let navigate = useNavigate();
  const [userId, setUserID] = useState("");
  const [userError, setUserError] = useState(false);
  // api call to change password
  const forgotPasswordApi = async () => {
    const storeToken = localStorage.getItem("ssoToken");
    try {
      const getToken = await axios.post(
        Login_Page.Forgot_Password,

        {
          empCode: userId,
        },

        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
          },
        }
      );
      if (getToken.data.message == "Failed to send mail") {
        toast.error("Failed to sent mail");
      } else {
        toast.success("Mail sent successfully");
        setTimeout(() => {
          navigate("/");
        }, 2000);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleForgotPassword = (e) => {
    e.preventDefault();
    if (userId.length > 0) {
      forgotPasswordApi();
      setUserError(false);
    } else {
      setUserError("Enter Correct UserName");
    }
  };

  const handleUserId = (e) => {
    setUserID(e.target.value);
  };

  return (
    <>
      <div className="form-wrapper">
        <form
          className="form login-form"
          onSubmit={handleForgotPassword}
          noValidate
        >
          <Formnav />
          <h2 className="form-title">{Constants.Forgot_Pass}</h2>
          <h4 className="form-info">{Constants.Password_Reset_Link}</h4>
          <label htmlFor="name" className="form-label">
            Email <span className="mandatory-label">*</span>
          </label>
          <input
            type="text"
            // name="userID"
            className="form-input"
            placeholder="Enter your Email"
            onChange={handleUserId}
            maxLength={10}
          />
          <p className="forget-link">
            <span>{userError}</span>
            <Link to="/">{Constants.Back_Login}</Link>
          </p>

          {/* <!-- submit btn --> */}
          <button className="form-submit" type="submit">
            {Constants.Submit}
          </button>
        </form>
      </div>
    </>
  );
}

export default ForgetPasswordForm;
